import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import type { ChannelScope } from 'features/channels/models';

export const useNavigateToOrganizationChannel = () => {
  const navigate = useNavigate();

  return useCallback(
    async (id: string, scope: ChannelScope) => {
      await navigate(routes.channels.organizationChannel(id, scope));
    },
    [navigate],
  );
};
